import React, { useState, useEffect } from "react";
import GalleyModal from "./GalleyModal";
import AddEditProgress from "./AddEditProgress";
import { Services } from "../../../../api/Services";
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import bmiIcon from "../../../../images/bmi.svg";
import gymimage from "../../../../images/apple.png";
import AssignTrainer from "./AssignTrainer";
import { BASE_URL_MEDIA } from "../../../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';

const formatDate = (dateString) => {
  const dateObject = new Date(dateString);
  const year = dateObject.getFullYear();
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const day = String(dateObject.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// code added by zohaib
const ProgressModel = ({
  userId,
  myId,
  trainersList,
  setTrainersList,
  loadingTrainers,
  fetchBodyChangesTrainers,
}) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [bmi, setBmi] = useState(null);
  const [weight, setWeight] = useState(null);
  const [desc, setDesc] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  const [porgressType, setProgressType] = useState("");
  const [editStatus, setEditStatus] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [settingIndex, setSettingIndex] = useState(null);
  const [traingingType, setTrainingType] = useState("pre");
  const [progressData, setProgressData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [newImages, setNewImages] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [page, setPage] = useState(1);
  const [haseMoreDate, setHasMoredata] = useState(true);
  const [totalPages, setTotalPages] = useState(null);
  const [addEditLoader, setAddEditLoader] = useState(false);
  const [showTrainerForm, setShowTrainerForm] = useState(false);

  const setPreTraining = async () => {
    setPage(1);
    setTotalPages(null);
    setTrainingType("pre");
    setShowSettings(false);
    setSettingIndex(null);
  };
  const setPostTraining = async () => {
    setPage(1);
    setTotalPages(null);
    setTrainingType("post");
    setShowSettings(false);
    setSettingIndex(null);
  };
  useEffect(() => {
    fetchBodyChanges(traingingType);
  }, [traingingType]);

  // api call to get user body change stats
  const fetchBodyChanges = async (traingingType) => {
    setIsLoading(true);
    try {
      const result = await Services.getBodyChanges(1, traingingType, userId);
      if (result.status === 200) {
        setProgressData(result?.data?.data?.list);
        setTotalPages(result?.data?.paging?.total_pages);
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching the User Body Changes Data",
        error
      );
      toast.error(
        "An error occurred while fetching the User Body Changes Data",
        {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        }
      );
      return;
    }
    setIsLoading(false);
  };

  // for load more body changes on page scoll
  const loadMore = async () => {
    try {
      if (page + 1 < totalPages + 1) {
        const result = await Services.getBodyChanges(
          page + 1,
          traingingType,
          userId
        );
        if (result.status === 200) {
          const responseData = result.data.data;
          if (responseData.list.length > 0) {
            setProgressData([...progressData, ...responseData.list]);
            setPage(page + 1);
          } else {
            setHasMoredata(false);
          }
        }
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching the User Body Changes Data",
        error
      );
      toast.error(
        "An error occurred while fetching the User Body Changes Data",
        {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        }
      );
    }
  };

  // api call to add user body change stats
  const addEditBodyChanges = async (data) => {
    setAddEditLoader(true);
    try {
      const result = await Services.addEditBodyChanges(data);
      if (result.status === 200) {
        if (!editStatus && newImages.length > 0) {
          const uploadPromis = newImages.map((image) => {
            return addBodyChsngesImage(image, result?.data?.data?.id);
          });
          await Promise.all(uploadPromis);
          handleCloseBodyChangeForm();
        }

        toast.success("Body Change Added successfully", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error("An error occurred while Adding Body Changes", error);
      toast.error("An error occurred while Adding Body Changes", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    setAddEditLoader(false);
  };

  // api call to delete user body change
  const deleteBodyChanges = async (id) => {
    try {
      const result = await Services.deleteBodyChanges(id);
      if (result.status === 200) {
        toast.success("Body Canges Deleted successfully", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error("An error occurred while Deleting Body Changes", error);
      toast.error("An error occurred while Deleting Body Changes", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
  };
  // api call to add user body change images
  const addBodyChsngesImage = async (image, selectedCardId) => {
    try {
      const data = new FormData();
      data.append("image", image);
      data.append("body_changes_id", selectedCardId);
      const result = await Services.addBodyChangesImage(data);
      if (result.status === 200) {
        toast.success("Body Changes Added successfully", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error(
        "An error occurred while Deleting Body Changes Image",
        error
      );
      toast.error("An error occurred while Deleting Body Changes Image", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    setIsLoading(false);
  };

  // api call to delete user body change images
  const deleteBodyChangeImage = async (id) => {
    setIsLoading(true);
    try {
      const result = await Services.deleteBodyChangeImage(id);
      if (result.status === 200) {
        toast.success("Body Changes Image Deleted successfully", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error(
        "An error occurred while Deleting Body Changes Image",
        error
      );
      toast.error("An error occurred while Deleting Body Changes Image", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    setIsLoading(false);
  };

  // api call to remove user body changes trainer
  const deleteBodyChangeTrainer = async (user_ids) => {
    try {
      const userIdsArray = [parseInt(user_ids)];
      const result = await Services.removeBodyChangesTrainer(userIdsArray);
      if (result.status === 200) {
        toast.success("Body Changes Trainer Removed successfully", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error(
        "An error occurred while Removing Body Changes Trainer",
        error
      );
      toast.error("An error occurred while Removing Body Changes Trainer", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
  };

  const removeTrainer = (user) => {
    const confirmed = window.confirm("Do you want to remove this Trainer?");
    if (confirmed) {
      setTrainersList(trainersList.filter((e) => e.trainer?.id !== user));
      deleteBodyChangeTrainer(JSON.stringify(user));
    }
  };

  const addEditProgress = () => {
    return (
      <AddEditProgress
        handleCloseForm={handleCloseBodyChangeForm}
        bmi={bmi}
        setBmi={setBmi}
        weight={weight}
        setWeight={setWeight}
        desc={desc}
        setDesc={setDesc}
        selectedImages={selectedImages}
        setSelectedImages={setSelectedImages}
        newImages={newImages}
        setNewImages={setNewImages}
        porgressType={porgressType}
        setProgressType={setProgressType}
        editStatus={editStatus}
        handleSubmit={handleSubmit}
        deleteBodyChangeImage={deleteBodyChangeImage}
        addEditLoader={addEditLoader}
      />
    );
  };

  const assignTrainer = () => {
    return (
      <AssignTrainer handleCloseAssignTrainer={handleCloseAssignTrainer} />
    );
  };

  const handleCloseAssignTrainer = () => {
    setShowTrainerForm(false);
    fetchBodyChangesTrainers();
  };

  const handleSubmit = async () => {
    if (porgressType === "") {
      toast.error("Progress Type Cannot be Empty", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    if (weight === null && bmi === null && desc === "") {
      toast.error("Please Fill At Leat One Filed", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    const data = new FormData();
    if (porgressType) data.append("type", porgressType);
    if (weight) data.append("weight", weight);
    if (bmi) data.append("bmi", bmi);
    if (desc) data.append("desc", desc);
    if (selectedCardId && editStatus) data.append("id", selectedCardId);
    if (userId) data.append("user_id", userId);
    await addEditBodyChanges(data);
    if (editStatus && newImages.length > 0) {
      const uploadPromis = newImages.map((image) => {
        return addBodyChsngesImage(image, selectedCardId);
      });
      await Promise.all(uploadPromis);
    }
    handleCloseBodyChangeForm();
  };

  const handleOpenBodyChangeForm = async () => {
    setProgressType(traingingType);
    setShowAddModal(true);
    setShowSettings(false);
    setSettingIndex(null);
    setProgressData([]);
  };

  const handleCloseBodyChangeForm = async () => {
    setShowAddModal(false);
    setEditStatus(false);
    setWeight(null);
    setBmi(null);
    setDesc("");
    setProgressType("");
    setSelectedImages([]);
    setNewImages([]);
    setPage(1);
    setHasMoredata(true);
    setTotalPages(null);
    fetchBodyChanges(traingingType);
  };

  const handleEditProgress = (data) => {
    setEditStatus(true);
    setWeight(data.weight);
    setBmi(data.bmi);
    setDesc(data.desc);
    setSelectedImages(data.images);
    setProgressType(traingingType);
    setShowAddModal(true);
    setShowSettings(false);
    setSettingIndex(null);
  };

  const handleDeleteProgress = async (data, index) => {
    const confirmed = window.confirm("Do you want to remove this Body Change?");
    if (confirmed) {
      try {
        if (data.images.length > 0)
          await Promise.all(
            data.images.map((image) => deleteBodyChangeImage(image.id))
          );

        await deleteBodyChanges(data.id);

        const updatedProgressData = [...progressData];
        updatedProgressData.splice(index, 1);
        setProgressData(updatedProgressData);
        handleCardSettingClick(data, index);
      } catch (error) {
        console.error("An error occurred while deleting body change:", error);
      }
    }
  };

  const handleCardSettingClick = (data, index) => {
    if (showSettings && settingIndex === index) {
      setShowSettings(false);
      setSelectedCardId(null);
    } else {
      setShowSettings(true);
      setSettingIndex(index);
      setSelectedCardId(data.id);
    }
  };

  return (
    <div className="progess-data">
      <div className="pre-post my-3">
        <button
          onClick={() => setPreTraining()}
          className={`${traingingType == "pre" ? "active" : ""}`}
        >
          Before Program
        </button>
        <button
          onClick={() => setPostTraining()}
          className={`${traingingType == "post" ? "active" : ""}`}
        >
          After Program
        </button>
      </div>
      {userId == myId && (
        <div className="progress-trainer-section">
          <div className="assing-trainer-btn-section">
            <h1>Trainers who can see your photos</h1>
            <div className="add-triner-btn">
              <div
                className="add-trainer"
                onClick={() => setShowTrainerForm(true)}
              >
                Add New Trainer
              </div>
            </div>
          </div>
          <div className="form-selected-users progress-trainers">
            {!loadingTrainers ? (
              <ul>
                {trainersList.length > 0 ? (
                  trainersList.map((suser) => (
                    <li key={suser?.id}>
                      <div className="img">
                        <i
                          className="fa fa-times"
                          onClick={() => removeTrainer(suser?.trainer?.id)}
                        ></i>
                        {suser?.trainer?.image ? (
                          <img
                            src={getImageUrl(suser?.trainer?.image, BASE_URL_MEDIA)}
                          />
                        ) : (
                          <img src={gymimage} alt="imgae-girl" />
                        )}
                      </div>
                      <span className="name">{suser?.trainer?.name}</span>
                    </li>
                  ))
                ) : (
                  <div className="no-trainers-data">
                    <h1>No Trainer Added </h1>
                  </div>
                )}
              </ul>
            ) : (
              <div class="three-body">
                <div class="three-body__dot"></div>
                <div class="three-body__dot"></div>
                <div class="three-body__dot"></div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="progress-add-btn">
        <div
          className="add-progress"
          onClick={() => handleOpenBodyChangeForm()}
        >
          Add New Progress
        </div>
      </div>

      {showTrainerForm && assignTrainer()}
      {showAddModal && addEditProgress()}
      {!isLoading ? (
        <InfiniteScroll
          dataLength={progressData.length}
          next={loadMore}
          hasMore={haseMoreDate}
          scrollableTarget="right-small"
          className="inifinty-scroll-progress"
        >
          {progressData.length > 0 ? (
            progressData.map((data, index) => (
              <div className="progress_container">
                <div className="setting-icons">
                  <div class="paste-button">
                    <div
                      className="setting-icon-box"
                      onClick={() => handleCardSettingClick(data, index)}
                    >
                      <i
                        class={
                          settingIndex === index && showSettings
                            ? "fa fa-cog fa-spin"
                            : "fa fa-cog"
                        }
                        style={{
                          color: `${
                            settingIndex === index && showSettings
                              ? "#3659c8"
                              : "black"
                          }`,
                        }}
                        title="List Settings"
                      ></i>
                    </div>
                    {showSettings && settingIndex === index && (
                      <div class="dropdown-content">
                        <a
                          id="top"
                          href="#"
                          onClick={() => handleEditProgress(data)}
                        >
                          <i
                            className="fa-solid fa-pen-to-square"
                            title="Show List"
                          ></i>
                          Edit Progress
                        </a>

                        <a
                          id="bottom"
                          href="#"
                          onClick={() => handleDeleteProgress(data, index)}
                        >
                          <i
                            className="fa-solid fa-trash-can"
                            title="Delete List"
                          ></i>
                          Delete Progress
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                <div className="pre-post-stats my-3">
                  <p className="pp-name">
                    <i className="fa fa-dumbbell"></i>
                    <b>Weight: </b>
                    {data.weight}
                  </p>
                  <p className="pp-name">
                    <img
                      className="progress-bmi-icon"
                      src={bmiIcon}
                      alt="bmi"
                    />
                    <b>BMI: </b>
                    {data.bmi}
                  </p>
                  <p className="pp-name pp-data">
                    <i className="fa fa-calendar-days"></i>
                    {formatDate(data.updated_at)}
                  </p>
                </div>
                <div className="pp-des">{data.desc}</div>
                <GalleyModal images={data.images} />
              </div>
            ))
          ) : (
            <div className="no-progress-data">
              <h1>No Progress Data</h1>
            </div>
          )}
        </InfiniteScroll>
      ) : (
        <div class="three-body">
          <div class="three-body__dot"></div>
          <div class="three-body__dot"></div>
          <div class="three-body__dot"></div>
        </div>
      )}
    </div>
  );
};

export default ProgressModel;
